(() => {
  'use strict';
  const root = document.querySelector('.sh-page');
  if (!root) return;
  const params = new URLSearchParams(location.search);
  const theme = params.get('preview_theme_id');
  if (theme) root.querySelectorAll('a[href]').forEach(a => {
    const raw = a.getAttribute('href');
    if (!raw || raw.startsWith('#')) return;
    const url = new URL(raw, location.href);
    if (url.origin === location.origin || url.hostname === 'steadyshe.com') {
      if (url.pathname.startsWith('/products/') || url.pathname === '/' || url.pathname === '/cart' || url.pathname.startsWith('/policies/')) {
        url.searchParams.set('preview_theme_id', theme);
        a.href = url.href;
      }
    }
  });
  root.querySelectorAll('.sh-cart-count').forEach(el => { if (el.textContent.trim() === '0') el.hidden = true; });
  const closeMenu = () => document.dispatchEvent(new Event('ss:close-menu'));

  let returnFocus = null;
  const videoDialog = root.querySelector('#sh-video-dialog');
  const player = videoDialog.querySelector('video');
  const status = videoDialog.querySelector('.sh-video-status');
  let playbackRequest = 0;
  const clearVideo = () => {
    playbackRequest += 1;
    player.pause();
    player.querySelectorAll('track').forEach(track => track.remove());
    player.removeAttribute('src');
    player.removeAttribute('poster');
    player.load();
  };
  const showDialog = (dialog, trigger) => {
    if (!dialog) return;
    returnFocus = trigger;
    closeMenu();
    dialog.showModal();
    document.body.style.overflow = 'hidden';
  };
  root.querySelectorAll('[data-dialog]').forEach(button => button.addEventListener('click', () => showDialog(document.getElementById(button.dataset.dialog),button)));
  root.querySelectorAll('[data-video]').forEach(button => button.addEventListener('click', () => {
    videoDialog.querySelector('#sh-video-title').textContent = button.dataset.title;
    videoDialog.querySelector('.sh-transcript p').textContent = button.dataset.transcript;
    videoDialog.querySelector('.sh-transcript').open = false;
    const story=root.querySelector(`template[data-story-for="${button.dataset.storyKey||''}"]`);
    const drawer=videoDialog.querySelector('[data-home-story-drawer]');
    const copy=drawer.querySelector('[data-home-story-copy]');
    copy.replaceChildren();drawer.querySelector('details').open=false;
    if(story){
      const content=story.content.cloneNode(true);
      drawer.querySelector('h3').textContent=content.querySelector('h3')?.textContent||'';
      content.querySelector('h3')?.remove();copy.append(content);
      drawer.querySelector('[data-home-story-toggle]').textContent=`Read ${story.dataset.storyName}’s full story`;
    }
    drawer.hidden=!story;
    videoDialog.querySelector('.sh-transcript').hidden=Boolean(story);
    videoDialog.classList.toggle('sh-video-dialog--story',Boolean(story));
    status.textContent = '';
    clearVideo();
    const request = playbackRequest;
    const cover = button.querySelector('img.sh-video-image');
    if (cover) player.poster = cover.currentSrc || cover.src;
    player.src = button.dataset.video;
    if (button.dataset.captions) {
      const track = document.createElement('track');
      track.kind = 'captions';
      track.srclang = 'en';
      track.label = 'English';
      track.src = button.dataset.captions;
      track.default = true;
      player.append(track);
      track.track.mode = 'showing';
    }
    showDialog(videoDialog,button);
    player.play().catch(() => {
      if (videoDialog.open && request === playbackRequest) {
        status.textContent = 'Press play to watch the story. You can also read it below.';
      }
    });
  }));
  player.addEventListener('error', () => { status.textContent = 'The video could not load. Please try again, or read the story below.'; });
  player.addEventListener('playing', () => { status.textContent = ''; });
  root.querySelectorAll('dialog').forEach(dialog => {
    dialog.querySelector('[data-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if (e.target === dialog) { const r=dialog.getBoundingClientRect(); if(e.clientX<r.left || e.clientX>r.right || e.clientY<r.top || e.clientY>r.bottom) dialog.close(); } });
    dialog.addEventListener('close', () => {
      if (dialog === videoDialog) clearVideo();
      document.body.style.overflow = '';
      if (returnFocus && document.contains(returnFocus)) returnFocus.focus({preventScroll:true});
    });
  });
  const sticky = root.querySelector('.sh-mobile-shop');
  const hero = root.querySelector('.sh-hero');
  if ('IntersectionObserver' in window) new IntersectionObserver(entries => { sticky.hidden = entries[0].isIntersecting; }, {threshold:0}).observe(hero);
})();
